module.exports = __webpack_public_path__ + "img/bank_of_sanxiang@2x.2a43c5c3.png";